<template>
  <div class="d-flex justify-content-between align-items-center h-100">
    <div style="    min-width: 60px;    margin-right: 5px;" class="mr-1">
      <img style="height: 35px; width: auto; cursor: pointer;" v-if="params.colDef.field === 'camera' && params.value" @click="openModal()" :src="attachmentUrl" />
      <img style="height: 35px; width: auto; cursor: pointer;" v-if="params.colDef.field === 'camera2' && params.value" @click="openModal()" :src="attachmentUrl" />
    </div>
    <span class="cursor-pointer" v-if="(userType === 'ADMIN' || userType === 'VIEWER') && params.colDef.field === 'camera' && params.data.video" @click="openVideoModal()">▶️</span>
    <span style="    margin-left: 5px;" v-if="userType === 'ADMIN' && params.colDef.field === 'camera' && params.data.video">{{ videoSize ? videoSize + ' MB' : '' }}</span>
    <span style="position: absolute; right: 0;" class="cursor-pointer" v-if="(userType === 'ADMIN' || userType === 'VIEWER') && params.colDef.field === 'camera2' && params.data.video2" @click="openVideoModal2()">▶️</span>
    <b-modal
        :id="`modal-attachment-${params.column.colId}-${params.data._id}`"
        :no-close-on-backdrop="true"
        centered
        size="lg"
        title="Լուսանկար"
        :is-valid="false"
        :hide-footer="true"
    >
      <b-form class="d-flex justify-content-center align-items-center" v-if="params.value">
        <span v-if="(userType === 'ADMIN' || userType === 'VIEWER')" class="createdDate">{{ fileCreated | formatDate }}</span>
        <span v-if="detectedCarRegNo && (userType === 'ADMIN' || userType === 'VIEWER')" class="detectedCarRegNoModalInfo">{{ detectedCarRegNo }}</span>
        <img class="w-100" :src="attachmentUrl" />
      </b-form>
    </b-modal>
    <b-modal
        v-if="(params.colDef.field === 'camera' || params.colDef.field === 'video') && params.data.video"
        :id="`modal-video-${params.column.colId}-${params.data._id}`"
        :no-close-on-backdrop="true"
        centered
        size="lg"
        title="Լուսանկար"
        :is-valid="false"
        :hide-footer="true"
    >
      <b-form class="d-flex justify-content-center align-items-center" v-if="params.value">
        <span v-if="(userType === 'ADMIN' || userType === 'VIEWER')" class="createdDate">{{ fileCreated | formatDate }}</span>
        <video :src="videoUrl" class="w-100" controls preload="auto" playsinline>
          <source :src="videoUrl" type="video/webm">
        </video>
      </b-form>
    </b-modal>
    <b-modal
        v-if="(params.colDef.field === 'camera2' || params.colDef.field === 'video3') && params.data.video2"
        :id="`modal-video-2-${params.column.colId}-${params.data._id}`"
        :no-close-on-backdrop="true"
        centered
        size="lg"
        title="Լուսանկար"
        :is-valid="false"
        :hide-footer="true"
    >
      <b-form class="d-flex justify-content-center align-items-center" v-if="params.value">
        <span v-if="(userType === 'ADMIN' || userType === 'VIEWER')" class="createdDate">{{ fileCreated | formatDate }}</span>
        <video :src="videoUrl2" class="w-100" controls preload="auto" playsinline>
          <source :src="videoUrl2" type="video/webm">
        </video>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

import techServiceModule from '@/store/tech-service/techServiceModule'
import store from '@/store'
import {BForm, BModal} from "bootstrap-vue";

export default {
  name: 'cell-renderer-can-edit',
  components: {BForm, BModal},
  data() {
    return {
      TECH_SERVICE_STORE_MODULE_NAME: 'techServiceModule',
      selectedCheckupId: null,
      selectedCheckup: null,
      selectedCheckupNumbers: [],
      videoSize: null,
      fileCreated: null,
    }
  },
  computed: {
    userType () {
      return atob(this.$store.state.user_type)
    },

    detectedCarRegNo() {
      const match = this.params.value.match(/\/([A-Z0-9]+)_attachment-/);
      return match ? match[1] : null;
    },

    user() {
      return this.$store.state.user
    },
    attachmentUrl() {
      let url = process.env.VUE_APP_API_URL;
      url += '/' + this.params.value;
      return url;
    },
    videoUrl() {
      let url = process.env.VUE_APP_API_URL;
      url += '/' + this.params.data.video;
      return url;
    },
    videoUrl2() {
      let url = process.env.VUE_APP_API_URL;
      url += '/' + this.params.data.video2;
      return url;
    },
  },
  created() {
    if (!store.hasModule(this.TECH_SERVICE_STORE_MODULE_NAME)) store.registerModule(this.TECH_SERVICE_STORE_MODULE_NAME, techServiceModule)
  },
  async mounted() {
    const videoMeta = await this.getVideoSizeMB()
    this.videoSize = videoMeta.size;
    this.fileCreated = await this.getCameraCreated();
  },
  methods: {
    async getVideoSizeMB() {
      const videoPath = '../../' + this.params.data.video
      const res = await this.$store.dispatch(
          `${this.TECH_SERVICE_STORE_MODULE_NAME}/getVideoSize`,
          videoPath
      );

      return res.data;
    },
    async getCameraCreated(index = 1) {
      let path = '../../' + this.params.value
      const res = await this.$store.dispatch(
          `${this.TECH_SERVICE_STORE_MODULE_NAME}/getVideoSize`,
          path
      );

      return res.data.createdAt;
    },
    openLink(link) {
      window.open(link, '_blank')
    },
    openModal() {
      // eslint-disable-next-line no-underscore-dangle
      this.$bvModal.show(`modal-attachment-${this.params.column.colId}-${this.params.data._id}`)
    },
    openVideoModal() {
      // eslint-disable-next-line no-underscore-dangle
      this.$bvModal.show(`modal-video-${this.params.column.colId}-${this.params.data._id}`)
    },
    openVideoModal2() {
      // eslint-disable-next-line no-underscore-dangle
      this.$bvModal.show(`modal-video-2-${this.params.column.colId}-${this.params.data._id}`)
    },
  },
}
</script>
